export class TransportError extends Error {
    code;
    constructor(message, code = "generic") {
        super(message);
        this.code = code;
        this.name = "TransportError";
    }
    static notConnected() {
        return new TransportError("Transport is not connected");
    }
    static commitOutcomeUnknown(message) {
        return new TransportError(message, "commit-outcome-unknown");
    }
    static capacityExceeded(message) {
        return new TransportError(message, "capacity-exceeded");
    }
    static rejectedBeforeExecution(message) {
        return new TransportError(message, "rejected-before-execution");
    }
}
